import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { WaterCalendar } from '@models/water-calendar';
import type { Observable } from 'rxjs';

/** Read-only occupancy calendar for one water. There is no write side — see `water-calendar.ts`. */
@Injectable({ providedIn: 'root' })
export class CrmWaterCalendarService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/crm/waters`;

  /**
   * @param from first night, inclusive (ISO date)
   * @param to last night, inclusive (ISO date) — a night, not a departure date
   */
  getCalendar(waterId: number, from: string, to: string): Observable<WaterCalendar> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.http.get<WaterCalendar>(`${this.baseUrl}/${waterId}/calendar`, { params });
  }
}
